import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core'
import { OrgBrowserOrgList } from '../../models/org-browser-org-list';
import { OrgBrowserView } from '../../models/org-browser-view';

@Component({
    selector: 'org-selector',
    templateUrl: './org-selector.component.html',
    styleUrls: ['./org-selector.component.scss']
})

export class OrgSelectorComponent implements OnInit {

    @Output() addOrgList: EventEmitter<number> = new EventEmitter();
    constructor() { }

    ngOnInit() {
    }

    onOrgExpand(org: OrgBrowserView): void {
        this.addOrgList.emit(org.orgId);
    }

}